module.exports = __webpack_public_path__ + "img/strafe.a952f87e.svg";